<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单详情
  -->
  <div class="pb50" v-loading="loading" v-title :data-title="detail.username">
    <div class="jbxx">
      <div class="j_left">
        <div class="touximg"> <img :src="baseurl + detail.user.avatarUrl" v-if="detail.user.avatarUrl"></img></div>
        <div>用户昵称 : {{ detail.user.nickName }}</div>
        <div>  </div>
        <div>用户id : {{ detail.user_id }}</div>
        <div>支付宝绑定账号 : {{ detail.user.mobile }}</div>
        <div class="touximg" @click="sfztz(baseurl + detail.portrait)" v-if="detail.portrait">
          <img :src="baseurl + detail.portrait"></img>
        </div>
      </div>

      <div class="j_right">
        <div class="rleft">
          <div class="dingdan"> 订单状态：
            <li class="d1">{{ detail.order_status.value == 40 ? '已驳回' : detail.state_text }}</li>
            <li class="d2">用户: {{ detail.usernum ? "已实名" : "未实名" }}</li>
            <li class="d3">订单: {{ detail.usernum ? "已实名" : "未实名" }}</li>
          </div>
          <div> 用户姓名：{{ detail.username }} 身份证号: {{ detail.usernum }}</div>
          <div> 手机号：{{ detail.user.mobile }} 性别：{{ xingbie }} 年龄：{{ age }} 注册时间： {{ detail.create_time }} </div>
          <div> 电子邮箱：{{ detail.user.email }} ip地址:{{ detail.ip }}</div>
          <div style="line-height:25px">

            <div>
              本站租赁情况 <br />
              <!-- {{ addressdd ? addressdd.merger_name : "" }}  -->
              1、下单地区:<div v-if="detail.country"> 【 {{ detail.country ? detail.country : "" }} {{ detail.province ? detail.province : "" }} {{
                detail.city ? detail.city : "" }} {{ detail.district ? detail.district : "" }} 】</div>
                <div v-else>
                  <!-- 【 用户未在手机上进行授权 】 -->
                </div>
            </div>
            审核提醒： <br />
            <div @click="oderTotal()">1、相同收货地址共计 <span class="xtsh">{{ dataCount.total }}</span> 笔(该笔订单不计算在内)</div>

            2、下单和收货地相符 <br />

            3、相同ip下单地址共计 {{ dataCount.ipcount }} 笔(该笔订单不计算在内) <br />

            4、该用户id有 {{ dataCount.user_idcount }} 笔租赁中订单; 身份证匹配有 {{ dataCount.usernumcount }} 笔租赁中订单
          </div>
        </div>
        <div class="rright">
          <div @click="sfztz(detail.user.sfzpositive)"> 身份证正面： <img :src="detail.user.sfzpositive"></img></div>
          <div @click="sfztz(detail.user.sfzback)"> 身份证反面： <img :src="detail.user.sfzback"></img></div>
        </div>
      </div>
    </div>

    <div class="nav">
      <div @click="ddxq(1)">
        <div :class="show == 1 ? 'dtclass' : ''">订单详情</div>
      </div>
      <div @click="ddxq(2)">
        <div :class="show == 2 ? 'dtclass' : ''">百融风控报告</div>
      </div>
      <!-- <div @click="ddxq(3)">
        <div :class="show == 3 ? 'dtclass' : ''">征信报告V1</div>
      </div> -->
<!--      <div @click="ddxq(10)">-->
<!--        <div :class="show == 10 ? 'dtclass' : ''">征信报告V2</div>-->
<!--      </div>-->
      <div @click="ddxq(10)">
        <div :class="show == 10 ? 'dtclass' : ''">征信报告</div>
      </div>
      <!-- <div @click="ddxq(4)">
        <div :class="show == 4 ? 'dtclass' : ''">欺诈分</div>
      </div> -->
      <div @click="ddxq(5)">
        <div :class="show == 5 ? 'dtclass' : ''">蚂蚁链代扣</div>
      </div>
      <div @click="ddxq(6)">
        <div :class="show == 6 ? 'dtclass' : ''">风控报告</div>
      </div>
      <!-- <div @click="ddxq(7)">
        <div :class="show == 7 ? 'dtclass' : ''">贷款报告</div>
      </div>
      <div @click="ddxq(8)">
        <div :class="show == 8 ? 'dtclass' : ''">逾期报告</div>
      </div> -->
      <div @click="ddxq(9)">
        <div :class="show == 9 ? 'dtclass' : ''">短信发送记录</div>
      </div>
    </div>

    <template v-if="show == 1">
      <div class="product-content">
        <!-- 个人信息 紧急联系人 -->
        <LIANXI :detailinfo=detail></LIANXI>
        <!--基本信息-->
        <div class="common-form">基本信息</div>
        <table border="1" style="border-collapse: collapse;width: 100%;" class="color49">
          <tr>
            <th> 订单号 </th>
            <th> 买家</th>
            <th> 订单金额 (元) </th>
            <th> 运费金额 (元)</th>
            <th> 优惠券抵扣 (元)</th>
            <!-- <th> 积分抵扣 (元) </th>
              <th> 满减金额 (元) </th> -->
            <th> 实付款金额 (元) </th>
            <th> 支付方式 </th>
            <th> 配送方式 </th>
            <th> 交易状态 </th>
            <!-- <th> 预付款支付状态 </th> -->
            <!-- <th> 预付款金额 </th> -->
            <th> 租赁期限 </th>
            <th> 租赁方式 </th>
            <th> 租赁时间 </th>
            <th> 是否已买断 </th>
            <th>买断价</th>
            <th> 买断时间 </th>
            <th> 下单渠道 </th>
            <th> 付款方式 </th>
            <th> 预收退款 </th>
            <th> 押金退款 </th>

            <!-- <th> 操作 </th> -->
          </tr>
          <tr>
            <th> <span> {{ detail.order_no }} </span> </th>
            <th> <span> 用户ID({{ detail.user.user_id }}) </span> </th>
            <th> <span> {{ detail.order_price }} </span> </th>
            <th> <span> {{ detail.express_price }} </span> </th>
            <th> <span v-if="detail.coupon_money > 0"> {{ detail.coupon_money }} </span> </th>
            <!-- <th> <span v-if="detail.points_money > 0"> {{ detail.points_money }} </span> </th>
              <th> <span v-if="detail.fullreduce_money > 0"> {{ detail.fullreduce_money }} </span> </th> -->
            <th> <span style="color: red;"> {{ payable }} </span> </th>
            <th> <span> {{ detail.pay_type.value == 20 ? '支付宝支付' : '' }} </span> </th>
            <th> <span> {{ detail.delivery_type.text }}</span> </th>
            <th> <span> {{ detail.order_status.value == 40 ? '已驳回' : detail.state_text }} </span> </th>
            <!-- <th> <span>  {{ detail.is_yushou == 2 ? "已支付" : "未支付" }} </span> </th> -->
            <!-- <th> <span>  {{ detail.yushou }} </span> </th> -->
            <th> <span> {{detail.lease_time}}期 </span> </th>
            <th> <span> {{ detail.lease_type == 2 ? '租完买断' : '租完即送' }}</span> </th>
            <th> <span> {{ detail.create_time }} - {{ create_timedata }} </span> </th>
            <th> <span> {{ detail.maiduan_no ? '是' : '否' }} </span> </th>
            <th><span> {{ detail.maiduan_no ? buy_out_price : '' }}</span></th>
            <th> <span v-if="detail.maiduan_no"> {{ detail.maiduantime | formatDate }} </span> <span v-else> </span> </th>
            <th> <span> 支付宝小程序 </span> </th>
            <th> <span> 按月支付 </span> </th>
            <th style="color: red;"> {{ detail.ys_fail_msg?detail.ys_fail_msg2 :"无" }}    </th>
            <th style="color: red;"> {{ detail.yj_fail_msg?detail.yj_fail_msg1 :"无" }}    </th>

            <!-- <th> <span  v-if="detail['pay_status']['value'] == 10 && detail['order_status']['value'] == 10 && detail['order_source'] == 10"
                v-auth="'/order/order/updatePrice'">  <el-button @click="editClick(detail)" size="small">修改价格</el-button> </span> </th> -->
          </tr>
        </table>
        <!-- <div class="common-form">租期</div> -->
        <!-- <el-checkbox-group v-model="shneheList">
                <el-checkbox v-for="item in orderBill" :checked="true" name="" :label="item.bill_id" :key="item.bill_id"
                  :disabled="true">{{ '第'+item.current_period + '期' }} {{ item.repayment_date | formatDate }} {{item.price + '元'}}</el-checkbox>
              </el-checkbox-group> -->

        <!-- 资金预授权--芝麻信息 -->
        <div class="common-form">资金预授权--芝麻信息(如果为空则无资金授权押金冻结)</div>
        <table border="1" style="border-collapse: collapse;width: 100%;" class="color49">
          <tr>
            <th> 累计冻结金额(元) </th>
            <th> 信用金额(元)</th>
            <th> 预交押金记录(元)</th>
            <th> 支付宝资金预授权订单号 </th>
            <th> 预授权类型</th>
            <th> 支付宝账号</th>
            <th> 创建时间 </th>
            <th> 状态 </th>
            <th> 驳回时间 </th>
          </tr>
          <tr>
            <th> <span> {{ detail.deposit }} </span> </th>
            <th> <span> {{ detail.deposit }} </span> </th>
            <th> <span> {{ ysqyjze }} </span> </th>
            <th> <span> {{ detail.auth_no }} </span> </th>
            <th> <span>信用预授权 </span> </th>
            <th> <span> {{ detail.user.open_id }} </span> </th>
            <th> <span> {{ detail.create_time }} </span> </th>
            <th> <span style="color: red;" v-if="detail.order_status.value != 40"> {{ detail.auth_no ? "已支付" : "未支付" }} </span>
              <span style="color: red;" v-else> {{ detail.order_status.value == 40 ? '已驳回' : detail.state_text }} </span>
            </th>
            <th> <span v-if="detail.bhtime != 0"> {{ detail.bhtime | formatDate }} </span> </th>
          </tr>
        </table>
        <!-- 预收租金 -->
        <div class="common-form">预收租金</div>
        <table border="1" style="border-collapse: collapse;width: 100%;" class="color49">
          <tr>
            <th> 订单号 </th>
            <th> 增加金额(元)</th>
            <th> 支付宝资金回调订单号</th>
            <th> 创建时间 </th>
            <th> 是否选择了碎屏险</th>
            <th> 状态</th>
            <th> 驳回时间 </th>
          </tr>
          <tr>
            <th> <span> {{ ysinfo.order_no }} </span> </th>
            <th> <span> {{ detail.yushou }} </span> </th>
            <th> <span> {{ ysinfo.transaction_id }} </span> </th>
            <th> <span> {{ ysinfo.create_time }} </span> </th>
            <th> <span> {{ sphxInfo }} </span> </th>
            <th>
              <span style="color: red;" v-if="detail.order_status.value != 40"> {{ ysinfo.transaction_id ? "已支付" : "未支付" }} </span>
              <span style="color: red;" v-else> {{ detail.order_status.value == 40 ? '已驳回' : detail.state_text }} </span>
            </th>
            <th> <span v-if="detail.bhtime != 0"> {{ detail.bhtime | formatDate }} </span> </th>
          </tr>
        </table>
        <!-- 密码弹窗 -->
        <el-dialog title="请输入密码" :visible.sync="dialogVisiblezdhk" width="20%">
          <div style="height:100px;">
            <el-input placeholder="请输入密码" v-model="zdhkinput" show-password></el-input>
            <div style="margin-top:20px;display: flex;justify-content:center;"><el-button type="primary"
                @click="zdhkqd()">确定</el-button></div>
          </div>
        </el-dialog>
        <!-- 租后管理 -->
        <!-- <div style="display:flex;justify-content:space-between;align-items: center;">
          <div class="common-form">租后管理</div>
          <div v-if="detail.submission_authorization == '' && detail.authorization_agreement == ''">
            <el-button @click="adwenjian(detail.folwid2)" type="primary" size="small">下载用户授权协议和个人信息授权书</el-button>
          </div>
          <div v-else>
            <div style="font-size:20px;">
              放款状态: <span style="color: red;">{{ detail.fkzt ? "完成" : "" }}</span>
            </div>
          </div>
        </div> -->

        <div v-if="lease_type == '1'">
          <el-table :data="orderBill" style="width: 100%" :row-style="{ height: '20px' }"
            :cell-style="{ padding: '0px' }">
            <el-table-column prop="order_id" label="id"> </el-table-column>
            <el-table-column prop="current_period" label="期数"> </el-table-column>
            <el-table-column prop="price" label="应还款金额(元)"> </el-table-column>
            <el-table-column prop="bill_id" label="订单编号"> </el-table-column>
            <el-table-column label="扣款时间">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div>{{ scope.row.repayment_date | formatDate }}</div>
              </template>
            </el-table-column>
            <el-table-column label="是否已还">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div v-if="scope.row.jieguo == '未还'" style="color:#FF0000">{{ scope.row.jieguo }}</div>
                <div v-if="scope.row.jieguo == '已还'" style="color:cornflowerblue">{{ scope.row.jieguo }}</div>
                <div v-if="scope.row.jieguo == '逾期'">{{ scope.row.jieguo }}</div>
              </template>
            </el-table-column>
            <el-table-column label="报送状态">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div>{{ scope.row.baosongstatus == 1 ? "成功" : "未报送" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="支付时间">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div v-if="scope.row.paytime">{{ scope.row.paytime | formatDate }}</div>
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="160">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div style="margin: 8px 0;">
                  <el-dropdown split-button>
                    更多操作
                    <el-dropdown-menu slot="dropdown">
                      <div class="anniu">
                        <el-button @click="zhengxin(scope.row)" type="danger" size="small"
                          v-if="scope.row.baosongstatus != 1">逾期代偿报送</el-button>
                      </div>
                      <div class="anniu">
                        <el-button @click="zhengxin1(scope.row)" type="success" size="small"
                          v-if="scope.row.baosongstatus != 1">主动还款报送</el-button>
                      </div>
                      <div class="anniu">
                        <el-button @click="zdhk1(scope.row)" type="warning" size="small">主动还款</el-button>
                      </div>
                      <div class="anniu" v-if="scope.row.kkTime && scope.row.jieguo=='未还'">
                        <el-button @click="deductMoney(scope.row)" type="danger" size="small">扣款</el-button>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else>
          <el-table :data="orderBill" style="width: 100%" :row-style="{ height: '20px' }"
            :cell-style="{ padding: '0px' }">
            <el-table-column prop="order_id" label="id"> </el-table-column>
            <el-table-column prop="current_period" label="期数"> </el-table-column>
            <el-table-column prop="price" label="应还款金额(元)"> </el-table-column>
            <el-table-column prop="bill_id" label="订单编号"> </el-table-column>
            <el-table-column label="扣款时间">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div>{{ scope.row.repayment_date | formatDate }}</div>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="jieguo" label="是否已还"> </el-table-column> -->
            <el-table-column label="是否已还">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div v-if="scope.row.jieguo == '未还'" style="color:#FF0000">{{ scope.row.jieguo }}</div>
                <div v-if="scope.row.jieguo == '已还'" style="color:cornflowerblue">{{ scope.row.jieguo }}</div>
                <div v-if="scope.row.jieguo == '逾期'">{{ scope.row.jieguo }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="active_repayment" label="是否主动还款"> </el-table-column>
            <el-table-column prop="refund_status_myl" label="蚂蚁链退款状态"> </el-table-column>
            <el-table-column label="报送状态">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div>{{ scope.row.baosongstatus == 1 ? "成功" : "未报送" }}</div>
              </template>
            </el-table-column>
            <el-table-column label="支付时间">
              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div v-if="scope.row.paytime">{{ scope.row.paytime | formatDate }}</div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="160">

              <template slot-scope="scope" v-if="!scope.row.is_top_row">
                <div style="margin: 8px 0;">
                  <el-dropdown split-button>
                    更多操作
                    <el-dropdown-menu slot="dropdown">
                      <div class="anniu">
                        <el-button @click="zhengxin(scope.row)" type="danger" size="small"
                          v-if="scope.row.baosongstatus != 1">逾期代偿报送</el-button>
                      </div>
                      <div class="anniu">
                        <el-button @click="zhengxin1(scope.row)" type="success" size="small"
                          v-if="scope.row.baosongstatus != 1">主动还款报送</el-button>
                      </div>
                      <div class="anniu">
                        <el-button @click="zdhk1(scope.row)" type="warning" size="small">主动还款</el-button>
                      </div>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>

          </el-table>
          <div style="margin-top: 8px">
            <div>
              <table border="1" style="border-collapse: collapse;width: 100%;">
                <tr>
                  <th> 用户id : {{ order_id }}</th>
                  <th>买断价{{ maiduan }}(元)</th>
                  <th><el-button @click="quxiaomaiduan()" type="warning" size="small"
                      style="margin:5px ;">取消买断</el-button></th>
                  <th> <el-button @click="huankuan()" type="danger" size="small" style="margin:5px ;">逾期代偿报送</el-button>
                  </th>
                  <th> <el-button @click="huankuan()" type="success" size="small" style="margin:5px ;">主动还款报送</el-button>
                  </th>
                </tr>
              </table>
            </div>

          </div>

        </div>

        <!-- 费用信息 -->
        <div class="common-form">费用信息</div>
        <table border="1" style="border-collapse: collapse;width: 100%;">
          <tr>
            <th> 订单总金额(￥) </th>
            <th> 收取押金(￥)</th>
            <th> 单价 </th>
            <th> 优惠金额(￥)</th>
            <th> 已付款金额(￥)</th>
            <th> 待支付金额(￥) </th>
          </tr>
          <tr>
            <th> <span> {{ detail.order_price }} </span> </th>
            <th> <span> {{ ysqyjze }} </span> </th>
            <th> <span> {{ detail.product[0].product_name }} </span> </th>
            <th> <span> {{ coupon_money }} </span> </th>
            <th> <span> {{ pricezq }} </span> </th>
            <th> <span> {{ weihuan }} </span> </th>
          </tr>
        </table>

        <!-- 弹窗 -->
        <el-dialog title="布尔征信" :visible.sync="dialogTableVisible1">
          <!-- <div class="sanyaosu"> {{sanyaosumsg}}</div> -->
        </el-dialog>
        <!-- 弹窗 -->
        <el-dialog title="布尔征信" :visible.sync="dialogTableVisible2">
          <!-- <div class="sanyaosu"> {{sanyaosumsg}}</div> -->
        </el-dialog>

        <!--商户信息-->
        <div class="common-form mt16">商户信息</div>
        <div class="table-wrap">
          <el-row>
            <el-col :span="5">
              <div class="pb16">
                <span class="gray9">商户名称：</span>
                {{ detail.supplier.name }}
              </div>
            </el-col>

          </el-row>
        </div>
        <!--商品信息-->
        <div class="common-form mt16">商品信息</div>
        <div class="table-wrap">
          <el-table size="small" :data="detail.product" border style="width: 100%">
            <el-table-column label="商品" width="400">
              <template slot-scope="scope">
                <div class="product-info">
                  <div class="pic"><img v-img-url="scope.row.image.file_path" /></div>
                  <div class="info">
                    <div class="name">{{ scope.row.product_name }}</div>
                    <div class="gray9" v-if="scope.row.product_attr != ''">{{ scope.row.product_attr }}</div>
                    <div class="orange" v-if="scope.row.refund">{{ scope.row.refund.type.text }}-{{
                      scope.row.refund.status.text
                    }}</div>
                    <div class="price">
                      <span
                        :class="{ 'text-d-line': scope.row.is_user_grade == 1, 'gray6': scope.row.is_user_grade != 1 }">￥
                        {{
                          scope.row.product_price
                        }}</span>
                      <span class="ml10" v-if="scope.row.is_user_grade == 1">
                        会员折扣价：￥ {{ scope.row.grade_product_price }}
                      </span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="product_no" label="商品编码"></el-table-column>
            <el-table-column prop="product_weight" label="重量 (Kg)"></el-table-column>
            <el-table-column prop="total_num" label="购买数量">
              <template slot-scope="scope">
                <p>x {{ scope.row.total_num }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="total_price" label="商品总价(元)">
              <template slot-scope="scope">
                <p>￥ {{ detail.order_price }}</p>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!--收货信息-->
        <div v-if="detail.delivery_type.value == 10">
          <div class="common-form mt16">收货信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">收货人：</span>
                  {{ detail.address.name }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">收货电话：</span>
                  {{ detail.address.phone }}
                </div>
              </el-col>
              <el-col :span="9">
                <div class="pb16">
                  <span class="gray9">收货地址：</span>
                  {{ detail.address.region.province }} {{ detail.address.region.city }} {{
                    detail.address.region.region
                  }}
                  {{ detail.address.detail }}
                </div>
              </el-col>
              <el-col :span="5" v-if="detail.delivery_status.value != 20">
                <div class="pb16">
                  <el-button type="text" size="small" @click='changeAdd'> 修改地址 </el-button>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="25">
                <div class="pb16">
                  <span class="gray9">备注：</span>
                  {{ detail.buyer_remark }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!--自提门店信息-->
        <template v-if="detail.delivery_type.value == 20">
          <div class="common-form mt16">自提用户信息</div>
          <div class="table-wrap" v-if="detail.extract">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系人：</span>
                  {{ detail.extract.linkman }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系电话：</span>
                  {{ detail.extract.phone }}
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="25">
                <div class="pb16">
                  <span class="gray9">备注：</span>
                  {{ detail.buyer_remark }}
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="common-form mt16">自提信息</div>
          <div class="table-wrap" v-if="detail.extract">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">门店ID:</span>
                  {{ detail.extractStore.store_id }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">门店名称：</span>
                  {{ detail.extractStore.store_name }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系人：</span>
                  {{ detail.extractStore.linkman }}
                </div>
              </el-col>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系电话：</span>
                  {{ detail.extractStore.phone }}
                </div>
              </el-col>
              <el-col :span="15">
                <div class="pb16">
                  <span class="gray9">门店地址：</span>
                  {{ detail.extractStore.region.province }}- {{ detail.extractStore.region.city }}- {{
                    detail.extractStore.region.region
                  }}-
                  {{ detail.extractStore.address }}
                </div>
              </el-col>
            </el-row>
          </div>
        </template>

        <!--无需发货-->
        <template v-if="detail.delivery_type.value == 30">
          <div class="common-form mt16">用户信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">联系手机：</span>
                  {{ detail.user.mobile }}
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="25">
                <div class="pb16">
                  <span class="gray9">备注：</span>
                  {{ detail.buyer_remark }}
                </div>
              </el-col>
            </el-row>
          </div>
        </template>

        <!--付款信息-->
        <!-- <div class="table-wrap" v-if="detail.pay_status.value == 20">
            <div class="common-form mt16">付款信息</div>
            <div class="table-wrap">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">应付款金额：</span>
                    {{ detail.pay_price }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">支付方式：</span>
                    {{ detail.pay_type.text=='微信支付'?'支付宝支付':'支付宝支付' }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">支付流水号：</span>
                    {{ detail.transaction_id }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">付款状态：</span>
                    {{ detail.pay_status.text }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">付款时间：</span>
                    {{ detail.pay_time }}
                  </div>
                </el-col>
              </el-row>
            </div>
          </div> -->

        <!--发货信息-->
        <div
          v-if="detail.pay_status.value == 20 && detail.delivery_type.value == 10 && [20, 21].indexOf(detail.order_status.value) === -1"
          v-auth="'/order/order/delivery'">
          <div v-if="detail.delivery_status.value == 10">
            <!-- 去发货 -->
            <div class="common-form mt16">去发货</div>
            <el-form size="small" ref="form" :model="form" label-width="100px">
              <el-form-item label="物流公司">
                <el-select v-model="form.express_id" placeholder="请选择快递公司">
                  <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index"
                    :value="item.express_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="物流单号">
                <el-input v-model="form.express_no" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="设备编号">
                <el-input v-model="form.equipment_no" class="max-w460"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div v-else="">
            <div class="common-form mt16">发货信息</div>
            <div class="table-wrap">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">物流公司：</span>
                    {{ detail.express.express_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16" style="color:#0043FF;">
                    <span class="gray9">物流单号：</span>
                    {{ detail.express_no }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">设备编号：</span>
                    {{ detail.equipment_no }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货状态：</span>
                    {{ detail.delivery_status.text }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货时间：</span>
                    {{ detail.delivery_time }}
                  </div>
                </el-col>

                <el-col :span="6">
                  <div class="pb16">
                    <span class="gray9">操作：</span>
                    <span style="color:#0043FF;cursor:pointer;" @click="xiugai()">修改</span>
                    <span style="color:#0043FF;cursor:pointer;" @click="wldh()">查询</span>
                  </div>
                </el-col>

              </el-row>
            </div>
          </div>
        </div>

        <!-- 物流修改弹窗 -->
        <el-dialog title="物流信息" :visible.sync="dialogVisiblewlfh" width="60%">
          <div>
            <div class="common-form mt16">去发货</div>
            <el-form size="small" ref="form" :model="form" label-width="100px">
              <el-form-item label="物流公司">
                <el-select v-model="detail.express_id" placeholder="请选择快递公司">
                  <el-option :label="item.express_name" v-for="(item, index) in expressList" :key="index"
                    :value="item.express_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="物流单号">
                <el-input v-model="detail.express_no" class="max-w460"></el-input>
              </el-form-item>
              <el-form-item label="设备编号">
                <el-input v-model="detail.equipment_no" class="max-w460"></el-input>
              </el-form-item>
            </el-form>
            <div style="margin-top: 10px;">
              <el-button @click="orderqd()">确 定</el-button>
              <el-button @click="dialogVisiblewlfh = false">取 消</el-button>
            </div>
          </div>
        </el-dialog>

        <!--门店自提核销-->
        <div
          v-if="detail.delivery_type.value == 20 && detail.pay_status.value == 20 && detail.order_status.value != 21 && detail.order_status.value != 20"
          v-auth="'/order/order/operate/extract'">
          <div class="common-form mt16">门店自提核销</div>
          <div v-if="detail.delivery_status.value == 10">
            <el-form size="small" ref="extract_form" :model="extract_form" label-width="100px">
              <el-form-item label="门店核销员">
                <el-select v-model="extract_form.order.extract_clerk_id" placeholder="点击选择">
                  <el-option :label="item.real_name" v-for="(item, index) in shopClerkList" :key="item.clerk_id"
                    :value="item.clerk_id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="买家取货状态 ">
                <el-radio v-model="extract_form.order.extract_status" :label="1">已取货</el-radio>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onExtract(detail.order_id)">确认核销</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div v-else class="table-wrap">
            <template v-if="detail.extractClerk">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">自提门店名称：</span>
                    {{ detail.extractStore.store_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销员：</span>
                    {{ detail.extractClerk.real_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销状态：</span>
                    <template v-if="detail.delivery_status.value == 20">
                      已核销
                    </template>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销时间：</span>
                    {{ detail.delivery_time }}
                  </div>
                </el-col>
              </el-row>
            </template>
          </div>
        </div>
        <!--取消信息-->
        <div class="table-wrap" v-if="detail.order_status.value == 20 && detail.cancel_remark != ''">
          <div class="common-form mt16">取消信息</div>
          <div class="table-wrap">
            <el-row>
              <el-col :span="5">
                <div class="pb16">
                  <span class="gray9">商家备注：</span>
                  {{ detail.cancel_remark }}
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <!--门店自提核销-->
        <div
          v-if="detail.delivery_type.value == 20 && detail.pay_status.value == 20 && detail.order_status.value != 21 && detail.order_status.value != 20">
          <div class="common-form mt16">门店自提核销</div>
          <div class="table-wrap">
            <template v-if="detail.extractClerk">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">自提门店名称：</span>
                    {{ detail.extractStore.store_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销员：</span>
                    {{ detail.extractClerk.real_name }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销状态：</span>
                    <template v-if="detail.delivery_status.value == 20">
                      已核销
                    </template>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">核销时间：</span>
                    {{ detail.delivery_time }}
                  </div>
                </el-col>
              </el-row>
            </template>
          </div>
        </div>
        <!--虚拟物品发货-->
        <div
          v-if="detail.delivery_type.value == 30 && detail.pay_status.value == 20 && detail.order_status.value != 21 && detail.order_status.value != 20"
          v-auth="'/order/order/delivery'">
          <div class="common-form mt16">虚拟商品发货</div>
          <div v-if="detail.delivery_status.value == 10">
            <div class="pb16">
              <span class="gray9">发货状态：</span>待发货
            </div>
          </div>
          <div v-else class="table-wrap">
            <template v-if="detail.virtual_content">
              <el-row>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货信息：</span>
                    {{ detail.virtual_content }}
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货状态：</span>
                    <template v-if="detail.delivery_status.value == 20">
                      已发货
                    </template>
                  </div>
                </el-col>
                <el-col :span="5">
                  <div class="pb16">
                    <span class="gray9">发货时间：</span>
                    {{ detail.delivery_time }}
                  </div>
                </el-col>
              </el-row>
            </template>
          </div>
        </div>
      </div>

      <div class="common-form mt16">操作信息</div>
      <el-table :data="beizhu" style="width: 100%">
        <el-table-column prop="user_name" label="操作者">
        </el-table-column>
        <el-table-column prop="create_time" label="操作时间" width="180">
        </el-table-column>
        <el-table-column prop="type" label="订单状态">
        </el-table-column>
        <el-table-column prop="content" label="备注">
        </el-table-column>
      </el-table>

      <!-- 物流弹框 -->
      <el-dialog title="物流状况" :visible.sync="dialogVisiblewl" width="50%">
        <el-table :data="wlList" style="width: 100%" height="600">
          <el-table-column prop="areaCode" label="Code">
          </el-table-column>
          <el-table-column prop="areaName" label="地区">
          </el-table-column>
          <el-table-column prop="context" label="内容">
          </el-table-column>
          <el-table-column prop="ftime" label="时间">
          </el-table-column>
          <el-table-column prop="status" label="状态">
          </el-table-column>
          <el-table-column prop="time" label="时间">
          </el-table-column>
        </el-table>
      </el-dialog>



      <!-- 添加备注弹框 -->
      <el-dialog title="添加商家备注" :visible.sync="dialogVisibletjbz" width="40%">
        <div style="display:flex;justify-content:center;align-items:center;height: 130px;">
          <div style="width:20%;">备注：</div>
          <el-input v-model="tjbzinput" placeholder="备注"></el-input>
        </div>
        <div style="display:flex;justify-content:flex-end;">
          <el-button @click="dialogVisibletjbz = false">关闭</el-button>
          <el-button type="success" @click="tijiaobz()">提交</el-button>
        </div>
      </el-dialog>


      <div class="common-button-wrapper">
        <el-button type="primary" @click="shuaxin()">刷新</el-button>
        <el-button type="primary" @click="tjbz()">添加备注</el-button>
        <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
        <el-button v-if="detail.order_status.text == '待审核'" size="small" type="primary"
          @click="showShenhe">审核该订单</el-button>
        <!--确认发货-->
        <template
          v-if="detail.pay_status.value == 20 && detail.delivery_type.value == 10 && [20, 21].indexOf(detail.order_status.value) === -1">
          <el-button size="small" type="primary" @click="onSubmit" v-if="detail.delivery_status.value == 10">确认发货
          </el-button>
        </template>
        <!--用户取消-->
        <template v-if="detail.pay_status.value == 20 && detail.order_status.value == 21">
          <el-button size="small" type="primary" @click="confirmCancel()">确认审核</el-button>
        </template>
      </div>

      <changeAddress :isChange="isChange" :addressData="addressData" @closeDialog='closeAddress'></changeAddress>
      <!-- <Shen v-if="shenhe" :open_edit="shenhe" :order_id="order_id" :order="shneheList" @close="closeShenhe($event, 'edit')"></Shen> -->
      <Shen v-if="shenhe" :open_edit="shenhe" :order_id="order_id" @close="closeShenhe($event, 'edit')"></Shen>
    </template>

    <template v-if="show == 2">
      <Fengkon :fkid=detail.user_id :order_id=detail.order_id></Fengkon>
    </template>
    <template v-if="show == 3">
      <ZHENGXIN :zxid=detail.user_id :order_id=detail.order_id :zxid2=detail.sirius_report></ZHENGXIN>
    </template>
    <template v-if="show == 10">
<!--      <ZHENGXINA :hrzx_authorization="detail.hrzx_authorization" :list="creditInvestigationList" :order_id=detail.order_id :zxid2=detail.sirius_report :zxid=detail.user_id></ZHENGXINA>-->
      <CZHENGXIN :hrzx_authorization="detail.hrzx_authorization" :list="creditInvestigationList" :order_id=detail.order_id :zxid2=detail.sirius_report :user_id=detail.user_id></CZHENGXIN>
    </template>
    <template v-if="show == 4">
      <YIDUN :zxid=detail.order_id :ant_shield=detail.ant_shield :auth_no=detail.auth_no></YIDUN>
    </template>
    <template v-if="show == 5">
      <MAYILIANDAIKOU :folwid2=detail.folwid2 :myloid=detail.order_id></MAYILIANDAIKOU>
    </template>
    <template v-if="show == 6">
      <BUERZHENGXIN :order_id=detail.order_id :user_id=detail.user_id :credit_report=detail.credit_report></BUERZHENGXIN>
    </template>
    <template v-if="show == 7">
      <DAIKUANBAOGAO :order_id=detail.order_id :query3=detail.query3_testBooleanDemo></DAIKUANBAOGAO>
    </template>
    <template v-if="show == 8">
      <YUQIBAOGAO :order_id=detail.order_id :query4=detail.query4_testBooleanDemo></YUQIBAOGAO>
    </template>
    <template v-if="show == 9">
      <DUANXIN :order_id=detail.order_id></DUANXIN>
    </template>

    <!-- 相同收货地址弹框 -->
    <el-dialog title="相同收货地址信息" :visible.sync="dialogVisiblexd" width="60%">
      <div>
        <el-table :data="orderList" style="width: 100%" max-height="530">
          <el-table-column label="订单号">
            <template slot-scope="scope">
              <span style="color:#3C8DC2;cursor: pointer;" @click="tiaozdd(scope.row.order_id)">{{
                scope.row.orderlist.order_no }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div class="d4">
                {{ scope.row.orderlist.order_status.value == 40 ? '已驳回' : scope.row.orderlist.state_text }}</div>
            </template>
          </el-table-column>
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.orderlist.username ? scope.row.orderlist.username : "null" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="地址">
            <template slot-scope="scope">
              <span> {{ scope.row.region.province }} {{ scope.row.region.city }} {{ scope.row.region.region }} {{
                scope.row.detail }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import DAIKUANBAOGAO from "../../fengkong/operation/detail5.vue";
import YUQIBAOGAO from "../../fengkong/operation/detail6.vue";
import DUANXIN from "../../fengkong/operation/duanxinindex.vue";
import OrderApi from "@/api/order.js";
import changeAddress from "@/components/order/changeAddress.vue";
import Shen from "./dialog/shenhe.vue";
import Fengkon from "../../fengkong/operation/detail.vue";
import ZHENGXIN from "../../fengkong/operation/detail1.vue";
import ZHENGXINA from "../../fengkong/operation/detail1a.vue";
import YIDUN from "../../fengkong/operation/detail2.vue";
import MAYILIANDAIKOU from "../../fengkong/operation/detail3.vue";
import BUERZHENGXIN from "../../fengkong/operation/detail4.vue";
import { deepClone } from "@/utils/base.js";
import Table from "../../product/product/part/spec/many/Table.vue";
import LIANXI from "./dialog/lianxi.vue";
import CZHENGXIN from '../../fengkong/operation/detail7.vue'
export default {
  components: {
    CZHENGXIN,
    changeAddress,
    Shen,
    Fengkon,
    ZHENGXIN,
    YIDUN,
    MAYILIANDAIKOU,
    BUERZHENGXIN,
    DAIKUANBAOGAO,
    YUQIBAOGAO,
    Table,
    DUANXIN,
    LIANXI,
    ZHENGXINA
  },
  data() {
    return {
      kkTime:[],
      creditInvestigationList:"",
      dialogVisiblewlfh: false,
      zdhkbill_id: "",
      zdhkinput: "",
      dialogVisiblezdhk: false,
      lease_type: "",
      order_id: "",
      panduan: "",
      maiduan: "",
      ysqyjze: "",
      buy_out_price: "",
      create_timedata: "",
      portrait: "",
      hasrenzheng_id: "",
      sphxInfo: "",
      yijiao: "",
      coupon_money: "",
      weihuan: "",
      pricezq: "",
      payable: "",
      total_price: "",
      dialogTableVisible1: false,
      dialogTableVisible2: false,
      orderList: [],
      dialogVisiblexd: false,
      xingbie: "",
      addressdd: "",
      dataCount: "",
      ysinfo: "",
      tjbzinput: "",
      dialogVisibletjbz: false,
      wlList: [],
      dialogVisiblewl: false,
      age: "", //年龄
      show: 1, //展示风控 订单详情
      baseurl: "https://mxy.haidiao888.com/",
      shenhe: false,
      shneheList: [],
      orderBill: [],
      active: 0,
      /*是否加载完成*/
      loading: true,
      /*订单数据*/
      detail: {
        pay_status: [],
        pay_type: [],
        delivery_type: [],
        user: {},
        address: [],
        product: [],
        order_status: [],
        extract: [],
        extract_store: [],
        express: [],
        delivery_status: [],
        extractClerk: [],
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*发货*/
      form: {
        /*订单ID*/
        express_id: 10001,
        /*订单号*/
        express_no: "",
        //设备编号
        equipment_no: "",
      },
      forms: {
        is_cancel: 1,
      },
      extract_form: {
        order: {
          extract_status: 1,
        },
      },
      order: {},
      delivery_type: 0,
      /*配送方式*/
      exStyle: [],
      /*门店列表*/
      shopList: [],
      /*当前编辑的对象*/
      userModel: {},
      /*时间*/
      create_time: "",
      /*操作备注*/
      beizhu: [],
      /*快递公司列表*/
      expressList: [],
      shopClerkList: [],
      /*是否打开编辑弹窗*/
      open_edit: false,
      isChange: false,
      addressData: {
        name: "",
        phone: "",
        region: {
          province: "",
          province_id: 0,
          city: "",
          city_id: 0,
          region: "",
          region_id: 0,
          detail: "",
        },
      },
    };
  },
  created() {
    /*获取列表*/
    this.getParams();
  },
  methods: {
    // 是否显示扣款
    isShowKK(){
      // 当前时间
      let data = new Date()
      let n = data.getFullYear();
      let y = data.getMonth() + 1;
      y = y < 10 ? "0" + y : y; //月补0
      let r = data.getDate();
      r = r < 10 ? "0" + r : r; //天补0
      let dates = `${n}-${y}-${r}`
      // let dates = '2023-09-24'
      this.orderBill.forEach((item,index)=>{
        let kkArr = []
        // 扣款时间
        let date = new Date(this.orderBill[index].repayment_date * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM; //月补0
        let d = date.getDate();
        d = d < 10 ? "0" + d : d; //天补0
        kkArr[0] = `${y}-${MM}-${d-1}`;
        kkArr[1] = `${y}-${MM}-${d}`;
        kkArr[2] = `${y}-${MM}-${d+1}`;
        item.kkTime = kkArr.indexOf(dates)!=-1?true:false
      })
    },
    // 扣款
    deductMoney(value){
      OrderApi.Deductmoney({order_id:value.order_id,bill_id:value.bill_id}).then(res=>{
        this.$message({
          type:"success",
          message: '扣款成功',
        })
      })
    },
    // 修改物流确定
    orderqd() {
      console.log(this.detail.express_id, this.detail.express_no, this.detail.equipment_no);
      let self = this;
      let param = {
        express_id: self.detail.express_id,
        express_no: self.detail.express_no,
        equipment_no: self.detail.equipment_no
      }
      if (param.express_id == null) {
        this.$message.error('请选择物流公司');
        return;
      }
      if (param.express_no == '') {
        this.$message.error('请填写物流单号');
        return;
      }
      let order_id = self.order_id;
      OrderApi.checkdelivery({
        param: param,
        order_id: order_id
      },
        true
      )
        .then(data => {
          self.loading = false;
          self.$message({
            message: '修改物流成功',
            type: 'success'
          });
          self.getParams();
          self.dialogVisiblewlfh = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 修改物流
    xiugai() {
      console.log("修改物流");
      this.dialogVisiblewlfh = true;
    },
    // 下载用户授权协议和个人信息授权书
    adwenjian(fid) {
      // console.log("下载用户授权协议和个人信息授权书",this.order_id,fid);
      this.$confirm("是否要进行下载?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          // console.log("======确定");
          let Params = {
            order_id: this.order_id,
            flowid: fid
          };
          OrderApi.downloadAgreement(Params, true)
            .then((res) => {
              // console.log("成功1", res);
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
              } else {
                this.$message({
                  message: '操作失败',
                  type: 'warning'
                });
              }
            })
            .catch((error) => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 取消买断
    quxiaomaiduan() {
      this.$confirm("确定要取消买断吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          // console.log("======确定");
          let Params = {
            order_id: this.order_id,
          };
          OrderApi.quxiaomaiduan(Params, true)
            .then((res) => {
              // console.log("成功1", res);
              this.$message({
                type: "success",
                message: "确认成功",
              });
            })
            .catch((error) => { });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 逾期代偿报送
    zhengxin(row) {
      this.$confirm('确定要逾期代偿报送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        let self = this;
        self.dialogTableVisible1 = true;
        console.log("还款", row);
        let Params = {
          order_id: row.order_id,
          billid: row.bill_id
        };
        OrderApi.yqhkbs(Params, true)
          .then((res) => {
            this.$message({
              type: "success",
              message: "确认成功",
            });
            self.getParams();
            self.sanyaosu = res.data.result;
          })
          .catch((error) => { });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 主动还款报送
    zhengxin1(row) {
      this.$confirm('确定要主动还款报送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        let self = this;
        self.dialogTableVisible2 = true;
        // console.log("还款", row);
        let Params = {
          order_id: row.order_id,
          billid: row.bill_id
        };
        OrderApi.hkbs(Params, true)
          .then((res) => {
            this.$message({
              type: "success",
              message: "确认成功",
            });
            self.sanyaosu = res.data.result;
            self.getParams();
          })
          .catch((error) => { });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 主动还款
    zdhk1(row) {
      console.log("主动还款", row.bill_id);
      this.zdhkbill_id = row.bill_id;
      this.dialogVisiblezdhk = true;
    },
    // 自动还款密码
    zdhkqd() {
      console.log("主动还款", this.zdhkinput);
      this.dialogVisiblezdhk = false;
      let Params = {
        password: this.zdhkinput
      }
      OrderApi.checkpwd2(Params, true)
        .then((res) => {
          console.log(res);
          this.zdhkinput = "";
          if (res.msg == "操作成功") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            let data = {
              bill_id: this.zdhkbill_id
            }
            OrderApi.activeRepayment(data, true)
              .then((res) => {
                console.log(res);
              })
              .catch((error) => { });
          } else {
            this.$message({
              message: "操作失败",
              type: "warning",
            });
          }

        })
        .catch((error) => { });
    },
    // 逾期代偿报送  主动还款报送
    huankuan() {
      this.$confirm('确定要进行操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        // console.log("this", this.order_id);
        let self = this;
        self.dialogTableVisible2 = true;
        let Params = {
          orderid: self.order_id,
        };
        OrderApi.zhengyin(Params, true)
          .then((res) => {
            // console.log("成功", res);
            self.sanyaosu = res.data.result;
            self.$message({
              type: "success",
              message: "确认成功",
            });
            // console.log("sanyaosu", self.sanyaosu);
          })
          .catch((error) => { });

      }).catch(() => {
        let self = this;
        self.$message({
          type: 'info',
          message: '已取消'
        });
      });



    },
    // 点击订单号跳转
    tiaozdd(id) {
      // console.log(id);
      let self = this;
      let params = id;
      let routeData = self.$router.resolve({ path: '/order/order/Detail', query: { order_id: params } });
      window.open(routeData.href, '_blank');
    },
    // 相同下单弹窗
    oderTotal() {
      // console.log("相同下单");
      this.dialogVisiblexd = true;
    },
    // 提交添加商家备注
    tijiaobz() {
      // console.log(this.tjbzinput, this.$route.query.order_id);
      OrderApi.saveopt(
        {
          order_id: this.$route.query.order_id,
          content: this.tjbzinput,
        },
        true
      )
        .then((data) => {
          this.loading = false;
          this.dialogVisibletjbz = false;
          this.tjbzinput = "";
          this.$message({
            message: "操作成功",
            type: "success",
          });
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    shuaxin() {
      this.loading = true;
      this.getParams();
    },
    // 添加备注
    tjbz() {
      this.dialogVisibletjbz = true;
    },
    // 跳转身份证
    sfztz(url) {
      window.open(url, "_blank");
    },
    // 查询物流
    wldh() {
      // console.log(this.$route.query.order_id, this.detail.express_no);
      OrderApi.queryWL(
        {
          order_id: this.$route.query.order_id,
        },
        true
      )
        .then((data) => {
          this.loading = false;
          this.dialogVisiblewl = true;
          // console.log("data", data.data.express.list);
          this.wlList = data.data.express.list;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    // 显示报告
    ddxq(val) {
      // console.log(val);
      this.show = val;
      // console.log(this.detail);
    },
    showShenhe() {
      // console.log(this.detail.shop_url.length, "地址信息");
      this.order_id = this.detail.order_id;
      this.shenhe = true;
      // 没有签署e签宝
      // if(this.detail.is_shop == 1){
      //   if(this.detail.shop_url.length == 0){
      //     this.$message({
      //         message: '该商品无合同可签',
      //         type: 'info'
      //       });
      //     return;
      // }else{
      //   this.shenhe = true;
      //   open(this.detail.shop_url)
      // }
      // }else{
      //   this.shenhe = true;
      // }
    },
    next() {
      if (this.active++ > 4) this.active = 0;
    },
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.order_id;
      OrderApi.orderdetail(
        {
          order_id: params,
        },
        true
      )
        .then((data) => {
          self.creditInvestigationList = data.data.creditInvestigationList;
          self.order_id = data.data.billList[0].order_id;
          self.lease_type = data.data.detail.lease_type;
          self.maiduan = data.data.buy_out_price;
          self.panduan = data.data.detail.user_buyout_states;
          self.loading = false;
          self.detail = data.data.detail;
          self.buy_out_price = data.data.buy_out_price;
          var buy_out_price = data.data.buy_out_price;
          self.hasrenzheng_id = data.data.detail.hasrenzheng_id;
          let str1 = data.data.detail.create_time;
          // console.log(str1.indexOf("2023") != -1,str1,"是否存在");
          // if (str1.indexOf("2023") != -1) {
          //   // console.log("存在");
          //   // console.log(str1.replace(/2023/,"2024"));
          //   self.create_timedata = str1.replace(/2023/, "2024");
          // }
          let times = str1.split('-')[1]//截取时间
          let shijia = str1.split('-')
          let returnTime = self.detail.lease_time//获取返回时间
          if(returnTime==12){
             self.create_timedata = str1.replace(/2023/, "2024");
          }else if(returnTime==9){
            let a = Number(times)+9
            if(a>12){
              let c = a - 12
              let b = Number(shijia[0])
              self.create_timedata = (b+1)+'-'+c+'-'+shijia[2]
            }else{
               let b = Number(shijia[0])
                self.create_timedata = (b+1)+'-'+a+'-'+shijia[2]
            }
            // console.log(a,999)
            //  .create_timedata = (times[0]+1)+a.slice(5,7)+9+times[2]
            //  console.log(self.create_timedata)
          }else if(returnTime==6){
            let a = Number(times)+6
            if(a>12){
              let c = a - 12
              let b = Number(shijia[0])
              self.create_timedata = (b+1)+'-'+c+'-'+shijia[2]
            }else{
               let b = Number(shijia[0])
                self.create_timedata = (b+1)+'-'+a+'-'+shijia[2]
            }
            // console.log(a,999)
            //  .create_timedata = (times[0]+1)+a.slice(5,7)+9+times[2]
            //  console.log(self.create_timedata)
          }else if(returnTime==3){
            console.log(self.detail.lease_time,333)
            let a = Number(times)+3
            if(a>12){
              let c = a - 12
              let b = Number(shijia[0])
              self.create_timedata = (b+1)+'-'+c+'-'+shijia[2]
            }else{
               let b = shijia[0]
                self.create_timedata = b +'-'+a+'-'+shijia[2]
                console.log(self.create_time,888)
            }
            // console.log(a,999)
            //  .create_timedata = (times[0]+1)+a.slice(5,7)+9+times[2]
            //  console.log(self.create_timedata)
          }
          if (self.hasrenzheng_id != '') {
            if (self.portrait == '' && self.detail.hasrenzheng == '1') {
              OrderApi.queryAttestation({
                order_id: self.$route.query.order_id,
                flowid: self.hasrenzheng_id
              },
                true
              )
                .then(data => {
                  self.loading = false;
                  console.log("成功");
                })
                .catch(error => {
                  self.loading = false;
                });
            }
          }

          self.orderList = Object.values(data.data.orderList);
          self.addressdd = data.data.address;
          self.dataCount = data.data.dataCount;
          self.expressList = data.data.expressList;
          self.beizhu = data.data.beizhu;
          // console.log("self.detail", self.detail.remarks_risk, self.detail.remarks_operation, self.detail.update_time);
          let beizhu1 = {
            app_id: 10001,
            content: self.detail.remarks_risk,
            create_time: self.detail.update_time,
            opt_log_id: 42,
            order_id: 1519,
            real_name: "管理员",
            shop_user_id: 10001,
            title: "",
            type: self.detail.order_status.value == 40 ? "已驳回" : self.detail.state_text,
            user_name: ""
          }
          let beizhu2 = {
            app_id: 10001,
            content: self.detail.remarks_operation,
            create_time: self.detail.update_time,
            opt_log_id: 42,
            order_id: 1519,
            real_name: "管理员",
            shop_user_id: 10001,
            title: "",
            type: self.detail.order_status.value == 40 ? "已驳回" : self.detail.state_text,
            user_name: ""
          }
          // console.log("beizhu1",beizhu1);
          self.beizhu.push(beizhu1);
          self.beizhu.push(beizhu2)
          if (data.data.ysinfo != null) {
            self.ysinfo = data.data.ysinfo;
          }
          self.shopClerkList = data.data.shopClerkList;
          self.addressData = self.detail.address;
          self.orderBill = data.data.billList;
          self.isShowKK()
          self.getsfz(self.detail.usernum);
          self.getxb(self.detail.usernum);
          // console.log(self.ysinfo, "ysinfo");
          // console.log("detail", data.data.detail);
          let yushou = self.detail.yushou;
          if (self.detail.is_yushou != 2) {
            yushou = 0;
          }
          let depositData = self.detail.deposit;
          let zhuanzujinData = self.detail.zhuanzujin;
          if (self.detail.auth_no == "") {
            depositData = 0;
          }
          if (self.detail.maiduan_no == "") {
            buy_out_price = 0;
          }
          self.detail.order_price =
            (Number(self.detail.order_price) -
              Number(self.detail.deposit) -
              Number(zhuanzujinData)).toFixed(2);
          let yujyj = Number(yushou) + Number(depositData);
          let ysqyjze = Number(zhuanzujinData) + Number(depositData);
          self.ysqyjze = ysqyjze.toFixed(2);
          // console.log(yujyj, "yushouyushou");
          self.total_price =
            Number(self.detail.total_price) + yujyj + +Number(zhuanzujinData);
          self.coupon_money =
            Number(self.detail.coupon_money) +
            Number(self.detail.coupon_money_sys);
          var str = self.detail.product[0].product_attr;
          // console.log(str.indexOf("不用") != -1, str, "是否存在");
          if (str.indexOf("不用") != -1 || str.indexOf("不") != -1) {
            // console.log("没有选择碎屏换新", str.indexOf("不用") != -1);
            self.sphxInfo = "否";
          } else {
            // console.log("选择了碎屏换新", str.indexOf("不用") != -1);
            self.sphxInfo = "是";
          }

          let qishu = 1;
          let pricezq = 0;
          let weihuan = 0;
          let payable = 0;
          for (let i = 0; i < self.orderBill.length; i++) {
            let order = self.orderBill[i];
            let order_id = order.order_id;

            if (order.is_pay_status == 1) {
              pricezq = Number(pricezq) + Number(order.price);
              if (order.transaction_id != null) {
                payable = Number(payable) + Number(order.price);
                // console.log(order.transaction_id, "order.transaction_id ");
              }
            }
            else if (order.is_pay_status == 0) {
              weihuan = Number(weihuan) + Number(order.price);
            } else if (order.is_pay_status == 2) {
              weihuan = Number(weihuan) + Number(order.price);
            }
            self.pricezq = pricezq.toFixed(2);
            self.weihuan = weihuan.toFixed(2);
            self.payable = (payable + ysqyjze + Number(yushou)).toFixed(2);
            // self.yijiao = Number(yujyj) + Number(pricezq) + Number(self.detail.zhuanzujin) + Number(buy_out_price);
            // console.log(
            //   yujyj,
            //   pricezq,
            //   payable,
            //   data.data.detail.zhuanzujin,
            //   "yijiaoyijiao"
            // );
            //扣款时间
            let date = new Date(order.create_time * 1000);
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM; //月补0
            let d = date.getDate();
            d = d < 10 ? "0" + d : d; //天补0
            let h = date.getHours();
            h = h < 10 ? "0" + h : h; //小时补0
            let m = date.getMinutes();
            m = m < 10 ? "0" + m : m; //分钟补0
            let s = date.getSeconds();
            s = s < 10 ? "0" + s : s; //秒补0
            var shijian = y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
            self.orderBill[i].shijian = shijian;

            //支付时间
            let date1 = new Date(order.repayment_date * 1000);
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y1 = date1.getFullYear();
            let MM1 = date1.getMonth() + 1;
            MM1 = MM1 < 10 ? "0" + MM1 : MM1; //月补0
            let d1 = date1.getDate();
            d1 = d1 < 10 ? "0" + d1 : d1; //天补0
            let h1 = date1.getHours();
            h1 = h1 < 10 ? "0" + h1 : h1; //小时补0
            let m1 = date1.getMinutes();
            m1 = m1 < 10 ? "0" + m1 : m1; //分钟补0
            let s1 = date1.getSeconds();
            s1 = s1 < 10 ? "0" + s1 : s1; //秒补0
            var shijian1 =
              y1 + "-" + MM1 + "-" + d1 + " " + h1 + ":" + m1 + ":" + s1;
            self.orderBill[i].shijian1 = shijian1;
            self.orderBill[i].qishu = qishu;
            qishu++;
            // console.log("is_pay_status", order.is_pay_status);
            if (order.is_pay_status == 0) {
              order.is_pay_status = "未还";
            } else if (order.is_pay_status == 1) {
              order.is_pay_status = "已还";
            } else {
              order.is_pay_status = "逾期";
            }

            if (order.active_repayment == 0) {
              order.active_repayment = "未进行主动还款";
            } else if (order.active_repayment == 1) {
              order.active_repayment = "主动还款";
            }

            if (order.refund_status_myl == 0) {
              order.refund_status_myl = "未退款";
            } else if (order.refund_status_myl == 1) {
              order.refund_status_myl = "已退款";
            }
            // console.log("refund_status_myl",order.active_repayment,order.refund_status_myl);
            self.orderBill[i].jieguo = order.is_pay_status;

            if (data.data.detail.yj_fail_msg == '') {
            if (data.data.detail.order_status.value == '40' || data.data.detail.order_status.value == '20') {

              data.data.detail.yj_fail_msg1= '成功'
            } else {
              data.data.detail.yj_fail_msg1 = '';
            }
          } else {
            data.data.detail.yj_fail_msg1 = '失败';
          }


          if (data.data.detail.ys_fail_msg == '') {
            if (data.data.detail.order_status.value == '40' || data.data.detail.order_status.value == '20') {
              data.detail.ys_fail_msg2 = '成功'
            } else {
              data.data.detail.ys_fail_msg2 = '';
            }
          } else {
            data.data.detail.ys_fail_msg2= '失败';
          }
          }
        })
        .catch((error) => {
          self.loading = false;
        });
    },

    // 身份证换算成年龄
    getsfz(iden) {
      let val = iden.length;
      let myDate = new Date();
      let month = myDate.getMonth() + 1;
      let day = myDate.getDate();
      let age = 0;

      if (val === 18) {
        age = myDate.getFullYear() - iden.substring(6, 10) - 1;

        if (
          iden.substring(10, 12) < month ||
          (iden.substring(10, 12) == month && iden.substring(12, 14) <= day)
        )
          age++;
      }
      if (val === 15) {
        age = myDate.getFullYear() - iden.substring(6, 8) - 1901;

        if (
          iden.substring(8, 10) < month ||
          (iden.substring(8, 10) == month && iden.substring(10, 12) <= day)
        )
          age++;
      }

      this.age = age;
    },

    // 身份证换算成年龄
    getxb(iden) {
      // console.log("fdsafsadfsa", iden);
      var str2 = iden;
      var num = str2.charAt(16);
      if (num % 2 == 0) {
        // console.log("女");
        this.xingbie = "女";
      } else if (num % 2 == 1) {
        // console.log("男");
        this.xingbie = "男";
      } else {
        // console.log("未知");
        this.xingbie = "未知";
      }
    },

    /*发货*/
    onSubmit() {
      let self = this;
      let param = self.form;
      if (param.express_id == null) {
        this.$message.error("请选择物流公司");
        return;
      }
      if (param.express_no == "") {
        this.$message.error("请填写物流单号");
        return;
      }
      let order_id = this.$route.query.order_id;
      OrderApi.delivery(
        {
          param: param,
          order_id: order_id,
        },
        true
      )
        .then((data) => {
          self.loading = false;
          self.$message({
            message: "恭喜你，发货成功",
            type: "success",
          });
          self.getParams();
        })
        .catch((error) => {
          self.loading = false;
        });
    },

    /*确认取消*/
    confirmCancel() {
      let self = this;
      let order_id = this.$route.query.order_id;
      let is_cancel = self.forms.is_cancel;
      OrderApi.toExamine(
        {
          order_id: order_id,
          is_cancel: is_cancel,
        },
        true
      )
        .then((data) => {
          self.loading = false;
          self.$message({
            message: "恭喜你，审核成功",
            type: "success",
          });
          self.getParams();
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    // 关闭弹窗
    closeShenhe(e, f) {
      if (f == "edit") {
        this.shenhe = e.openDialog;
        this.getParams();
      }
    },

    /*核销*/
    onExtract(e) {
      let self = this;
      let extract_form = self.extract_form;
      extract_form.order_id = e;
      OrderApi.extract(
        {
          extract_form,
        },
        true
      )
        .then((data) => {
          self.loading = false;
          self.$message({
            message: "恭喜你，操作成功",
            type: "success",
          });
          self.getParams();
        })
        .catch((error) => {
          self.loading = false;
        });
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_edit = e.openDialog;
        this.getParams();
      }
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    changeAdd() {
      this.isChange = true;
    },
    closeAddress(e) {
      let self = this;
      if (e == false) {
        self.isChange = false;
        console.log(e);
        return false;
      }
      let params = e.params;
      console.log(params);
      params.order_id = self.$route.query.order_id;
      OrderApi.updateAddress(params, true)
        .then((data) => {
          self.$message({
            message: "修改成功",
            type: "success",
          });
        })
        .catch((error) => { });
      self.isChange = false;
    },
  },
  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1 * 1000);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      let a = y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
      return a
    },
  },
};
</script>
<style>
.color49 {
  color: #495060;
}

.xtsh {
  cursor: pointer;
  color: #ffcf00;
  font-weight: bold;
  font-size: 18px;
}

.nav {
  width: 96%;
  height: 70px;
  background-color: #e8edf0;
  margin: 10px 0;
  display: flex;
  padding: 0 10px;
}

.nav div div {
  width: 100px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background-color: #d8e0e6;
  color: #939d9d;
  margin-top: 20px;
  margin-right: 6px;
}

.nav div .dtclass {
  background-color: #ffffff;
}

.jbxx {
  width: 100%;
  height: 400px;
  display: flex;
  color: white;
}

.jbxx .j_left {
  width: 25%;
  background-color: #6495ed;
  margin-right: 1%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.jbxx .j_left div {
  width: 100%;
  text-align: center;
  margin: 10px 0;
}

.jbxx .j_left .touximg {
  display: flex;
  justify-content: center;
}

.jbxx .j_left div img {
  width: 100px;
  height: 100px;
}

.jbxx .j_right {
  width: 70%;
  background-color: #6495ed;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: row;
}

.jbxx .j_right .rleft {
  width: 50%;
}

.jbxx .j_right div {
  margin: 5px 0;
}

.jbxx .j_right .dingdan {
  display: flex;
  align-items: center;
  height: 40px;
  color: white;
}

.jbxx .j_right .dingdan .d1 {
  width: 100px;
  text-align: center;
  list-style: none;
  border: 1px solid #ffa49f;
  margin: 0 5px;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
  font-size: 12px;
}

.jbxx .j_right .dingdan .d2 {
  width: 100px;
  text-align: center;
  list-style: none;
  border: 1px solid #c4efa2;
  margin: 0 5px;
  padding: 5px;
  background-color: #f6ffed;
  color: #76cc67;
  border-radius: 10px;
  font-size: 12px;
}

.jbxx .j_right .dingdan .d3 {
  width: 100px;
  text-align: center;
  list-style: none;
  border: 1px solid #c4efa2;
  margin: 0 5px;
  padding: 5px;
  background-color: #f6ffed;
  color: #76cc67;
  border-radius: 10px;
  font-size: 12px;
}

.jbxx .j_right .rright {
  width: 50%;
}

.jbxx .j_right .rright div {
  margin-bottom: 30px;
}

.jbxx .j_right .rright div img {
  width: 200px;
  height: 130px;
}

.orderlist {
  display: flex;
  justify-content: flex-start;
}

.d4 {
  width: 80px;
  text-align: center;
  list-style: none;
  border: 1px solid #ffa49f;
  margin: 0 5px;
  padding: 5px;
  background-color: #fff1f0;
  color: #f6363e;
  border-radius: 10px;
}

.anniu {
  margin-bottom: 5px;
}</style>



// WEBPACK FOOTER //
// src/views/order/received/detail.vue